/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MessageService } from '@src/app/shared/message.service';
import { FieldSet, FieldSetComponent, LAYOUT_OPTIONS } from '@src/app/shared/form/field-set/field-set.component';

import { FieldMaker } from '@src/app/shared/field/FieldMaker';
import { AbstractObject } from '@src/app/model/abstract-object';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { FormComboBoxComponent } from '@src/app/shared/form/form-combo-box/form-combo-box.component';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';

import { SupplierService } from '@src/app/modules/supply/supplier.service';
import { Supplier } from '@src/app/model/supplier';
import { SupplierPageNavRoute } from '@src/app/routes/supplier-page-nav';

@Component({
    selector: 'app-merge-supplier',
    imports: [MatDialogModule, FieldSetComponent, MatButtonModule],
    templateUrl: './merge-supplier.component.html',
    styleUrl: './merge-supplier.component.scss'
})
export class MergeSupplierComponent {
    dialogRef = inject(MatDialogRef<MergeSupplierComponent>);
    supplier = inject(MAT_DIALOG_DATA);
    mergeInto: Supplier;
    supplierSvc = inject(SupplierService);
    msgSvc = inject(MessageService);
    router = inject(Router);
    cds = inject(ConfirmDialogService);

    ready = false;

    fieldSet = new FieldSet({formLayout: LAYOUT_OPTIONS.singleCol});
    mergeIntoIdField = FormComboBoxComponent.make('Merge Into Supplier', 'mergeIntoSupplierId', null,
        { items: [],
          refreshes: [this.supplierRefresh.bind(this)],
        }
    )

    fields = [
        FieldMaker.idHolder('removeSupplierId'),
        this.mergeIntoIdField,
    ]

    constructor() {
        this.fieldSet.setFields(this.fields);
        this.fieldSet.setValue({ removeSupplierId: this.supplier.id } as unknown as AbstractObject);
        this.ready = true;
        this.supplierSvc.get(false, null, this.supplier.teamId).subscribe( contacts => {
            this.mergeIntoIdField.setPicklistItems(contacts.filter( (c: Supplier) => c.id !== this.supplier.id))
        })
    }

    supplierRefresh(supplier: Supplier) {
        if (supplier.id === this.supplier.id) {
            this.msgSvc.showErrorMessage($localize `Cannot merge ${this.supplier.fullName} on to themselves`);
        }
        console.log(supplier)
    }

    performMerge() {
        this.cds.open($localize `Are you 100% certain you want to merge `, $localize `This cannot be undone, are you you sure?`, () => {
            this.supplierSvc.performMerge(this.supplier, this.mergeIntoIdField.control.value).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.router.navigate([SupplierPageNavRoute.getIdUrl(r.id), {_forceTeam: this.supplier.teamId}]);
                }
            })
        });
    }
}
